module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-1.5-PositiveThoughts[Port]-52b33a2fe43c33dbf8814746746d82d4.pdf";